import { Gavel, Wrench, Users, Heart, FileText, CheckCircle } from "lucide-react";

const WhatPSAOADoes = () => {
  const responsibilities = [
    {
      icon: Gavel,
      title: "Governance",
      description: "Elected Executive Committee representing apartment owners. Decisions made in duly convened General Body Meetings are binding on all members.",
    },
    {
      icon: Wrench,
      title: "Facility Oversight",
      description: "Maintenance, repair, and management of all common areas and shared facilities within Purva Swanlake.",
    },
    {
      icon: Users,
      title: "Vendor Coordination",
      description: "Appointment, supervision, and control of service providers and facility management agencies. All vendors operate under PSAOA-approved contracts.",
    },
    {
      icon: Heart,
      title: "Resident Welfare",
      description: "Representation of apartment owners before government, statutory, judicial, and quasi-judicial authorities on matters affecting the community.",
    },
    {
      icon: FileText,
      title: "Compliance & Records",
      description: "Management of Association funds, accounts, audits, and records. Enforcement of By-Laws, rules, and codes of conduct.",
    },
    {
      icon: CheckCircle,
      title: "Legal Authority",
      description: "Initiation, defense, settlement, or compromise of legal proceedings relating to common property and collective interests.",
    },
  ];

  return (
    <section className="py-20 sm:py-28 bg-gradient-to-b from-white to-slate-50">
      <div className="section-container">
        <h2 className="section-title">What PSAOA Does</h2>
        <p className="section-subtitle">
          Our core responsibilities and governance functions
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {responsibilities.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="bg-white border-l-4 border-l-blue-600 border border-slate-200 rounded-lg p-6 hover:shadow-xl hover:border-blue-400 hover:border-l-blue-700 transition-all duration-300 transform hover:-translate-y-1 bg-gradient-to-br from-white to-slate-50 hover:to-blue-50"
              >
                <div className="flex items-start gap-4">
                  <div className="p-3 bg-gradient-to-br from-blue-100 to-blue-200 rounded-lg flex-shrink-0 transition-all duration-300 group-hover:bg-blue-300">
                    <Icon className="w-6 h-6 text-blue-700" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-bold text-lg text-foreground mb-2 transition-colors duration-300">
                      {item.title}
                    </h3>
                    <p className="text-sm text-muted-foreground leading-relaxed transition-colors duration-300">
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* Authority Note */}
        <div className="mt-12 bg-blue-50 border-l-4 border-blue-600 p-6 rounded-r-lg">
          <p className="text-blue-900">
            <span className="font-bold">Authority:</span> PSAOA is the duly constituted representative body of apartment owners for matters relating to common areas, facilities, and collective interests, as defined under its registered By-Laws and the Tamil Nadu Societies Registration Act, 1975.
          </p>
        </div>
      </div>
    </section>
  );
};

export default WhatPSAOADoes;
